module.exports = __webpack_public_path__ + "static/CrownRoyal2-c1b95348f2a740925247d927634ceab9.jpg";